// Menu Toggler
export function menuToggler() {
  const toggles = document.querySelectorAll('.toggle-menu');
  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      document.body.classList.toggle('menu-open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.body.classList.remove('menu-open');
    }
  });
}

// Fix 100vh Problem on Mobile browsers
export function mobileViewHeightFix () {
  const element = document.querySelector('.full-screen-height')

  if (element) {
    const viewportHeight = element.getBoundingClientRect().height
    element.style.height = viewportHeight + 'px'
  }
}

export function onLoadOrResize() {
  const winWidth = window.innerWidth
  if ( winWidth >= 1024 && document.body.classList.contains('menu-open') ) {
    document.body.classList.remove('menu-open');
  }
}

export function startupTheme() {
  document.body.style.setProperty(
    '--scrollBarWidth',
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );

  document.addEventListener("DOMContentLoaded", () => {
    menuToggler()
    mobileViewHeightFix()

    window.addEventListener('load', onLoadOrResize)
    window.addEventListener('resize', onLoadOrResize)
  });
}

console.log(`%c
       ___                         ___           ___           ___
      /  /\\                       /__/\\         /__/\\         /  /\\
     /  /:/_                      \\  \\:\\        \\  \\:\\       /  /::|
    /  /:/ /\\    ___     ___       \\  \\:\\        \\  \\:\\     /  /:/\:|
   /  /:/_/::\\  /__/\\   /  /\\  ___  \\  \\:\\   _____\\__\\:\\   /  /:/|:|__
  /__/:/__\\/\\:\\ \\  \\:\\ /  /:/ /__/\\  \\__\\:\\ /__/::::::::\\ /__/:/ |:| /\\
  \\  \\:\\ /~~/:/  \\  \\:\\  /:/  \\  \\:\\ /  /:/ \\  \\:\\~~\\~~\\/ \\__\\/  |:|/:/
   \\  \\:\\  /:/    \\  \\:\\/:/    \\  \\:\\  /:/   \\  \\:\\  ~~~      |  |:/:/
    \\  \\:\\/:/      \\  \\::/      \\  \\:\\/:/     \\  \\:\\          |  |::/
     \\  \\::/        \\__\\/        \\  \\::/       \\  \\:\\         |  |:/
      \\__\\/                       \\__\\/         \\__\\/         |__|/

 www.glunz.ch
 `, `font-family: monospace`);